export const getDefaultValue = (value, defaultValue) => value || defaultValue;
//# sourceMappingURL=getDefaultValue.js.map